import React from 'react';
import { dateToFiscalQuarterString } from 'javascripts/util/fiscalFormats';

export default class DeprecatedScaleMinorIntervals extends React.Component {
  wrapInSpans(text, classNames = []) {
    return text.split(' ').map((t, i) => (
      <span key={i} className={`interval-${classNames[i]}`}>
        {t}
      </span>
    ));
  }

  days() {
    if (this.props.scale.hideWeekends) {
      return ['M', 'T', 'W', 'T', 'F'];
    } else {
      if (window.currentUser && window.currentUser.startDay === 1) {
        return ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
      }
      return ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    }
  }

  dayInterval() {
    const { scale } = this.props;

    const majorIntervals = scale.majorIntervals();

    let pixelsPerDay = scale.pixelsPerDay;
    if (majorIntervals.length > 1) {
      // prefer to compute the pixelsPerDay directly if possible
      const offset1 = scale.dateToOffset(majorIntervals[0]);
      const offset2 = scale.dateToOffset(majorIntervals[1]);
      pixelsPerDay = (offset2 - offset1) / this.days().length;
    }

    return majorIntervals.map(date => {
      const offset = scale.dateToOffset(date);

      return this.days().map((day, index) => (
        <li
          key={`minor-intervals-${index}-s`}
          style={{ left: offset + index * pixelsPerDay, width: pixelsPerDay }}
        >
          <span className='interval-primary'>{day}</span>
        </li>
      ));
    });
  }

  weekInterval() {
    const { scale } = this.props;

    return scale.minorIntervals().map((date, index) => (
      <li key={this.key(index)} style={this.intervalStyle(date)}>
        <span className='interval-primary'>{date.format('D')}</span>
      </li>
    ));
  }

  monthInterval() {
    const { scale } = this.props;

    return scale.minorIntervals().map((date, index) => (
      <li key={this.key(index)} style={this.intervalStyle(date)}>
        <span className='interval-primary'>{date.format('MMM')}</span>
      </li>
    ));
  }

  quarterInterval() {
    const { scale } = this.props;

    return scale.minorIntervals().map((date, index) => {
      const value = dateToFiscalQuarterString(date, {
        fiscalMonth: this.props.scale.options.fiscalMonth,
        format: this.props.scale.options.fiscalYearFormat,
      });

      const classNames = /^Q/.test(value)
        ? ['primary', 'secondary']
        : ['secondary', 'primary'];
      return (
        <li key={this.key(index)} style={this.intervalStyle(date)}>
          {this.wrapInSpans(value, classNames)}
        </li>
      );
    });
  }

  intervalStyle(date) {
    const { scale } = this.props;

    return {
      left: scale.dateToOffset(date),
      width: scale.pixelsPerMinorInterval(),
    };
  }

  key(index) {
    return `minor-intervals-${index}`;
  }

  minorIntervals() {
    switch (this.props.scale.minorInterval) {
      case 'days':
        return this.dayInterval();
      case 'weeks':
        return this.weekInterval();
      case 'months':
        return this.monthInterval();
      case 'quarters':
        return this.quarterInterval();
    }
  }

  render() {
    return (
      <ul
        className={`minor-intervals minor-intervals--${this.props.scale.minorInterval}`}
      >
        {this.minorIntervals()}
      </ul>
    );
  }
}
